module.exports = __webpack_public_path__ + "service-picture.528a7580b94660eaeb2c.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/elements/service-picture.png
// module id = ../../../../../src/assets/elements/service-picture.png
// module chunks = 0